import {AuthService, OrderService} from 'hasta-la-vista-middleware-api/service'
export default {

    data(){
        return {
            loading: true,
            user: {FullName: null, Email: null, MobilePhone: null},
            order: {},
            saveUserData: false,
            saveNewsLetter: false,
            eft: false,
            leaveSite: false,
            isGuest: true
        }
    },

    methods: {
        checkPayment(){
            if (this.order.totalInCents == 0) {
                this.makePayment();
            } else {
                this.leaveSite = true;
            }
        },
        makePayment() {
            // console.log(this.order);
            let EFT = this.eft;
            this.leaveSite = false
            this.loading = true;
            if (this.saveUserData) {
                AuthService.storeLocalUserOrderInfo(this.user)
            }
            else if (this.user.isTemp) {
                AuthService.storeLocalUserOrderInfo(this.user, true)
            }
            else {
                console.log("not saving User Data", this.user);
            }
          OrderService.makePayment(EFT,this.user);
        },
    },

    created(){
        this.loading = true;
        Promise.all([AuthService.getUserOrderInfo(), OrderService.getOrder(), AuthService.isGuestUser()]).then(([userData,order, guest])=> {
            if (userData) this.user = userData
            this.isGuest = guest
            this.order = order;
            // console.log(this.order);
            this.loading = false;

        })
    },

    mounted(){
        window.scroll({top: 0, left: 0})
    },
}


// WEBPACK FOOTER //
// ./src/components/donate/confirm-details/confirm-details.js